import {StringMap} from 'utilities/types';
import {ServiceDimension} from 'sections/types';

interface ServiceMetrics {
  totalJobsCompleted: number;
  averageRating?: number | null;
  totalReviews: number;
}

interface ServiceListing {
  handle: string;
  serviceMetrics: ServiceMetrics;
}

export function serviceListingsToServiceDimensionsMap(
  serviceListings: ServiceListing[]
): StringMap<ServiceDimension> {
  return serviceListings.reduce(
    (map, serviceListing) => ({
      ...map,
      [serviceListing.handle]: {
        ...serviceListing.serviceMetrics,
      },
    }),
    {}
  );
}

export function fetchServiceDimensions(
  serviceDimensionsMap: StringMap<ServiceDimension> | undefined,
  serviceHandle: string
) {
  const defaultServiceDimension = {
    totalJobsCompleted: undefined,
    averageRating: undefined,
    totalReviews: undefined,
  };
  return (
    (serviceDimensionsMap && serviceDimensionsMap[serviceHandle]) ||
    defaultServiceDimension
  );
}
